// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntd[data-v-9c613a0a] p {\n    margin-bottom: 0;\n}\n.w-40[data-v-9c613a0a] {\n    width: 40% !important;\n}\n", ""]);
// Exports
module.exports = exports;
